<script>
import store from '@state/store'
import PostItem from '@router/components/post-item.vue'
import { authComputed } from '@state/helpers'
import MugenScroll from 'vue-mugen-scroll'

export default {
  components: {
    PostItem,
    MugenScroll,
  },
  props: {
    statusUpdates: { type: Array, required: true },
    noMorePosts: { type: Boolean, required: false },
    showCommentSection: { type: Boolean, required: false },
    loadingMore: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      lastPostPoints: 0,
      mobile: window.innerWidth <= 700,
    }
  },
  computed: {
    ...authComputed,
    shouldRefreshPostForm() {
      return this.refreshPostForm
    },
  },
  created() {
    addEventListener('resize', () => {
      this.mobile = innerWidth <= 700
    })
  },
  methods: {
    addLike(statusUpdateId) {
      store
        .dispatch('companies/likePost', {
          statusUpdateId: statusUpdateId,
          userId: this.currentUser.id,
        })
        .then((response) => {})
        .catch(() => {})
    },
    likeComment(params) {
      store
        .dispatch('companies/likeComment', {
          statusUpdateId: params.statusUpdateId,
          commentId: params.commentId,
          userId: this.currentUser.id,
        })
        .then((response) => {})
        .catch(() => {})
    },
    postComment(params) {
      store
        .dispatch('companies/postNewComment', {
          content: params.comment,
          statusUpdateId: params.statusUpdateId,
          userId: this.currentUser.id,
        })
        .then((newComment) => {})
        .catch(() => {})
    },
    toggleOverlay(params) {
      this.showOverlay = params.showHide
    },
    changeStatus(params) {
      store
        .dispatch('companies/changeStatus', {
          statusUpdateId: params.statusUpdateId,
          status: params.status,
        })
        .then((newPost) => {})
        .catch(() => {})
    },
    fetchMoreStatusUpdates() {
      this.$emit('fetch-more-status-updates')
    },
  },
}
</script>

<template>
  <div class="overflow-hidden rounded-xl">
    <p v-if="!statusUpdates.length" class="px-2 mb-4 post-content">
      Not posts here, yet.
    </p>
    <template v-else>
      <PostItem
        v-for="(singlePost, index) in statusUpdates"
        :key="singlePost.id"
        :one-post="singlePost"
        :post-index="index"
        :is-last="index === Object.keys(statusUpdates).length - 1"
        :show-comment-section="showCommentSection"
        @add-like="addLike"
        @like-comment="likeComment"
        @post-comment="postComment"
        @change-status="changeStatus"
      >
      </PostItem>
      <MugenScroll
        v-if="!mobile && !noMorePosts"
        :handler="fetchMoreStatusUpdates"
        :should-handle="!loadingMore"
      >
        <span class="block mx-auto mt-8 text-center">Loading...</span>
      </MugenScroll>
      <button
        v-if="mobile && !noMorePosts"
        class="block mx-auto mt-8 button primary-button"
        @click="fetchMoreStatusUpdates"
      >
        Load More
      </button>
    </template>
  </div>
</template>
